var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Input from 'components/Input.vue';
import { json } from 'overmind';
import { deburr, escapeRegExp, isEmpty } from 'lodash';
import { formatDateToBR } from '@/shared/utils/helpers';
import { mixpanelTracking } from '@/services/mixpanel';
let LegalAndTaxPanel = class LegalAndTaxPanel extends Vue {
    constructor() {
        super(...arguments);
        this.valueFilter = json(this.dateFilter);
        this.filteredFilters = json(this.filters);
        this.valueCheckbox = false;
        this.filterOptions = this.filters.map(f => f.filterOptions);
        this.searchTerm = '';
        this.currentFilterIndex = 0;
        this.selectedItemsOnCheckBoxes = {};
    }
    selectedCount(filter) {
        if (filter.queryType === 'multiSelect') {
            return filter
                ? filter.filterOptions.filter(option => option.isSelected).length
                : 0;
        }
        if (filter.queryType === 'rangeDate') {
            return !isEmpty(this.valueFilter[filter.queryField].toDate) &&
                !isEmpty(this.valueFilter[filter.queryField].inDate)
                ? 1
                : 0;
        }
    }
    warnBeginDateField(queryField) {
        const inDate = this.valueFilter[queryField].inDate;
        const toDate = this.valueFilter[queryField].toDate;
        return isEmpty(inDate) && !isEmpty(toDate);
    }
    warnEndDateField(queryField) {
        const inDate = this.valueFilter[queryField].inDate;
        const toDate = this.valueFilter[queryField].toDate;
        return !isEmpty(inDate) && isEmpty(toDate);
    }
    onSearchFilters(filter, event) {
        if (event == null) {
            this.filteredFilters[this.currentFilterIndex].filterOptions = json(this.filterOptions[this.currentFilterIndex]);
            return;
        }
        const filterOptions = json(this.filterOptions[this.currentFilterIndex].filter(o => {
            o.isSelected = this.selectedItemsOnCheckBoxes[o.value] ? true : false;
            const deburedTerm = escapeRegExp(deburr(this.searchTerm));
            if (o.tags) {
                const debured = deburr(Array.isArray(o.tags) ? o.tags.join(', ') : [o.tags].join(', '));
                const deburedMatch = debured.match(new RegExp(deburedTerm, 'gi'));
                if (deburedMatch)
                    return deburedMatch;
            }
            const deburedLabel = o.label ? deburr(o.label) : undefined;
            return o.label && deburedLabel
                ? deburedLabel.match(new RegExp(deburedTerm, 'i'))
                : false;
        }));
        this.filteredFilters[this.currentFilterIndex].filterOptions =
            json(filterOptions);
    }
    onHideFilter(filterIndex) {
        if (this.fullTextTerm === '') {
            this.filteredFilters[filterIndex].filterOptions = json(this.filters[filterIndex].filterOptions);
        }
    }
    onShowFilter(filterIndex, filterTitle) {
        mixpanelTracking('filtros avançados: Expandiu o grupo de filtros: ' + filterTitle);
        this.currentFilterIndex = filterIndex;
        this.searchTerm = '';
    }
    setDateValue(queryField) {
        this.$emit('setDateValue', {
            inDate: this.valueFilter[queryField].inDate,
            toDate: this.valueFilter[queryField].toDate,
            queryField: queryField,
        });
    }
    setCheckbox(filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId) {
        const option = this.filteredFilters[filterIndex].filterOptions.find(o => o.value === itemId);
        if (option) {
            this.filteredFilters[this.currentFilterIndex].filterOptions[filterOptionIndex].isSelected = value;
        }
        this.selectedItemsOnCheckBoxes[itemId] = value;
        this.$emit('setCheckbox', filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId);
    }
    formatDateFilters(dateFilter) {
        Object.keys(dateFilter).forEach(filter => {
            if (dateFilter[filter].inDate && dateFilter[filter].toDate) {
                this.valueFilter[filter].inDate =
                    dateFilter[filter].inDate.indexOf('-') > -1
                        ? formatDateToBR(dateFilter[filter].inDate)
                        : dateFilter[filter].inDate;
                this.valueFilter[filter].toDate =
                    dateFilter[filter].toDate.indexOf('-') > -1
                        ? formatDateToBR(dateFilter[filter].toDate)
                        : dateFilter[filter].toDate;
            }
        });
    }
    formatTitle(title) {
        switch (title) {
            case 'Situação modalidade simples':
                return 'Situação na modalidade Simples Nacional';
            case 'Data de inicio da modalidade simples (se optante pelo simples)':
                return 'Data de início da modalidade Simples Nacional (se optante)';
            case 'Data exclusão modalidade simples (se anteriormente foi optante pelo simples)':
                return 'Data de exclusão da modalidade Simples Nacional (se optante anteriormente)';
            case 'Data da ultima atualização de registro no CNPJ':
                return 'Data da última atualização de registro no CNPJ';
            default:
                return title;
        }
    }
    onFullTextSearchChange(curr, old) {
        this.searchTerm = this.fullTextTerm;
        if (this.fullTextTerm !== '') {
            this.filters.forEach(f => {
                this.onSearchFilters(f, this.fullTextTerm);
                this.currentFilterIndex += 1;
            });
            this.currentFilterIndex -= 1;
        }
    }
    onCurrentFilterIndexChange(curr, old) {
        this.filterOptions[curr] =
            this.filters[this.currentFilterIndex].filterOptions;
    }
    onFiltersChange(curr, old) {
        if (curr) {
            this.filters = curr;
        }
    }
    mounted() {
        this.searchTerm = this.fullTextTerm;
        if (this.fullTextTerm !== '') {
            this.filters.forEach(f => {
                this.onSearchFilters(f, this.fullTextTerm);
                this.currentFilterIndex += 1;
            });
            this.currentFilterIndex -= 1;
        }
        this.formatDateFilters(this.dateFilter);
        this.filteredFilters.forEach((e, i) => {
            e.filterOptions.forEach(element => {
                if (element.isSelected) {
                    this.selectedItemsOnCheckBoxes[element.value] = true;
                }
            });
        });
    }
};
__decorate([
    Prop({ default: () => { } })
], LegalAndTaxPanel.prototype, "dateFilter", void 0);
__decorate([
    Prop({ default: () => [] })
], LegalAndTaxPanel.prototype, "filters", void 0);
__decorate([
    Prop({ default: '' })
], LegalAndTaxPanel.prototype, "fullTextTerm", void 0);
__decorate([
    Prop({ default: 0 })
], LegalAndTaxPanel.prototype, "filterGroupId", void 0);
__decorate([
    Watch('fullTextTerm')
], LegalAndTaxPanel.prototype, "onFullTextSearchChange", null);
__decorate([
    Watch('currentFilterIndex')
], LegalAndTaxPanel.prototype, "onCurrentFilterIndexChange", null);
__decorate([
    Watch('filters')
], LegalAndTaxPanel.prototype, "onFiltersChange", null);
LegalAndTaxPanel = __decorate([
    Component({
        name: 'LegalAndTaxPanel',
        components: {
            Input,
        },
    })
], LegalAndTaxPanel);
export default LegalAndTaxPanel;
